import { request } from "@umijs/max";

// LINE連携開始（POST /line/link/start）
export async function startLineLink(options?: { [key: string]: any }) {
  return request<{ authorizeUrl: string }>('/line/link/start', {
    method: 'POST',
    ...(options || {}),
  });
}
